import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { FORM_KEYS } from "../../../constants";

/**
 * @desc Schema.
 */
const createYupObject = (pskus) => {
  return yup.object({
    [FORM_KEYS.ADD_PRODUCT_SKU]: yup
      .string()
      .required("Required")
      .matches(/^[a-zA-Z-_0-9]*$/gi, () => "AlphaNumeric Hypens Only")
      .notOneOf(pskus, "Product SKU already exists"),
  });
};

/**
 * @desc Hook for validating login form.
 */
export const useProductSKUForm = (pskus, defaultValues = {}) => {
  return useForm({
    resolver: yupResolver(createYupObject(pskus)),
    mode: "all",
    defaultValues,
  });
};
